import { Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IPrintFile } from '../../../../../../common/common-interfaces/print-file';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';

@Component({
    selector: 'print-file',
    templateUrl: './print-file.component.html',
    styleUrls: ['./print-file.component.scss'],
    standalone: false
})
export class PrintFileComponent {
  printFileId: string;
  printFile: IPrintFile;
  url: SafeResourceUrl;
  private paramsSubscription: Subscription | null = null;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, private globals: Globals, private sanitizer: DomSanitizer) {

  }

  async ngOnInit() {

    this.paramsSubscription = this.route.params.subscribe(async (params) => {
      if (params['id']) {
        this.printFileId = params['id'];
        this.printFile = await this.api.store().get<any>(`/print-files/${this.printFileId}`);

        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`/api/stores/by-access-code/${this.globals.accessCode}/admin/print-files/${this.printFileId}/data`);
      }
    });
  }

  ngOnDestroy(): void {
    (this.paramsSubscription as Subscription).unsubscribe();

  }


}


